var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 98.0001C76.062 98.0001 98.0001 76.062 98.0001 49C98.0001 21.9381 76.062 0 49 0C21.9381 0 0 21.9381 0 49C0 76.062 21.9381 98.0001 49 98.0001Z",
    fill: "#25292E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 98.0001C76.062 98.0001 98.0001 76.062 98.0001 49C98.0001 21.9381 76.062 0 49 0C21.9381 0 0 21.9381 0 49C0 76.062 21.9381 98.0001 49 98.0001Z",
    fill: "url(#paint0_linear_1513_4812)",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.665 51.698L49.0001 63.7286L69.3311 51.698L49.0001 80.3573L28.665 51.698Z",
    fill: "url(#paint1_linear_1513_4812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0001 59.2472L28.665 47.2167L49.0001 15.1899L69.3351 47.2167L49.0001 59.2472Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1513_4812",
    x1: 0,
    y1: 0,
    x2: 49,
    y2: 98.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1513_4812",
    x1: 48.9981,
    y1: 51.698,
    x2: 48.9981,
    y2: 80.3573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumIcon);
export default __webpack_public_path__ + "static/media/ethereum-icon.985e763e06ce31ca939f303aabbecbf8.svg";
export { ForwardRef as ReactComponent };